import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowAlignVerticalCentre32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconArrowAlignVerticalCentre32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M29 16a1 1 0 0 1-1 1h-5.821l2.528 2.528a1 1 0 0 1-1.414 1.414L19.05 16.7l-.707-.707.707-.707 4.243-4.243a1 1 0 0 1 1.414 1.414L22.164 15H28a1 1 0 0 1 1 1M16 6a1 1 0 0 1 1 1v18a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1m-6.164 9-2.543-2.543a1 1 0 1 1 1.414-1.414l4.243 4.243.707.707-.707.707-4.243 4.243a1 1 0 0 1-1.414-1.415L9.82 17H4a1 1 0 1 1 0-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowAlignVerticalCentre32);
